export const FLAG_GETTING_CABIN_CREW_BUS_ASSIGNMENTS =
  'FLAG_GETTING_CABIN_CREW_BUS_ASSIGNMENTS';
export const GET_CABIN_CREW_BUS_ASSIGNMENTS = 'GET_CABIN_CREW_BUS_ASSIGNMENTS';
export const CLEAR_CABIN_CREW_BUS_ASSIGNMENTS = 'CLEAR_CABIN_CREW_BUS_ASSIGNMENTS';
export const FLAG_CABIN_CREW_BUS_ASSIGNMENT_ACTIVITY =
  'FLAG_CABIN_CREW_BUS_ASSIGNMENT_ACTIVITY';
export const GET_CABIN_CREW_BUS_ASSIGNMENT = 'GET_CABIN_CREW_BUS_ASSIGNMENT';
export const CLEAR_CABIN_CREW_BUS_ASSIGNMENT = 'CLEAR_CABIN_CREW_BUS_ASSIGNMENT';
export const CABIN_CREW_BUS_ASSIGNMENT_INITIAL_VALUES =
  'CABIN_CREW_BUS_ASSIGNMENT_INITIAL_VALUES';
